import { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { listEventsApi } from "../services/apiCall";
import { formatDate } from "../utils/dateUtils";
import { usePagination } from "../hooks/usePagination";
import { useInfiniteScroll } from "../hooks/useInfiniteScroll";
import "./styles/RecentEventsList.css";

const DEFAULT_FILTERS = {};
export default function RecentEventsList({ filters = DEFAULT_FILTERS }) {
  const businessId = useSelector((state) => state?.user?.businessId);

  const fetchEventsFn = useCallback(async () => {
    if (!businessId) return [];
    try {
      const response = await listEventsApi(businessId, filters);
      console.log("API response:", response);
      return response?.data || [];
    } catch (err) {
      console.error("Failed to fetch upcoming events:", err);
      throw err;
    }
  }, [businessId, filters]);

  const {
    displayedData: upcomingEvents,
    loading,
    error: hookError,
    loadMore,
    hasMore,
  } = usePagination(fetchEventsFn, { dependencies: [businessId, filters] });

  // Infinite Scroll
  const lastElementRef = useInfiniteScroll(loading, hasMore, loadMore);

  const errorMessage = hookError ? "Could not load upcoming events." : null;

  const isOverdue = (dueDate) => {
    return new Date(dueDate) < new Date();
  };

  return (
    <section className="upcoming-events-widget">
      <div className="widget-header">
        <h2>Upcoming Events</h2>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner" />
          <p>Loading upcoming events...</p>
        </div>
      ) : errorMessage ? (
        <div className="error-state">
          <p>{errorMessage}</p>
        </div>
      ) : upcomingEvents.length === 0 ? (
        <div className="empty-state">
          <p>No upcoming events</p>
        </div>
      ) : (
        <div className="events-list">
          {upcomingEvents.map((event) => {
            const overdue = isOverdue(event.dueDate);

            return (
              <div
                key={event.id}
                className={`event-card ${overdue ? "overdue" : ""}`}
              >
                <div className="event-header">
                  <span
                    className={`priority-dot priority-${
                      event.priority || "medium"
                    }`}
                  />
                  <h3 className="event-title">{event.title || "Untitled"}</h3>
                </div>

                <p className="event-category">
                  {event.category || "No category"}
                </p>

                <div className="event-meta">
                  <p className={`event-date ${overdue ? "overdue-date" : ""}`}>
                    {formatDate(event.dueDate)}
                    {overdue && <span className="overdue-tag">Overdue</span>}
                  </p>
                  <span
                    className={`status-badge status-${event.status || "todo"}`}
                  >
                    {event.status?.toUpperCase() || "TODO"}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {hasMore && (
        <div
          ref={lastElementRef}
          className="pagination-controls"
          style={{ textAlign: "center", marginTop: "15px" }}
        >
          {loading ? (
            <span style={{ fontSize: "14px", color: "#888" }}>
              Loading more events...
            </span>
          ) : (
            <span style={{ fontSize: "14px", color: "#888" }}>
              Scroll for more
            </span>
          )}
        </div>
      )}
    </section>
  );
}
